import React, { useState, useEffect } from 'react';
import { PrepAdminLayout } from '../../../components/prep/PrepAdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PrepAdminCertContent = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/prep/content/prep-programs`).then(r => setContent(r.data)).catch(console.error);
  }, []);

  const set = (key, val) => setContent(prev => ({ ...prev, [key]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/prep/content/prep-programs`, { data: content }, { withCredentials: true });
      toast.success('Certification Prep page updated');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!content) return <PrepAdminLayout title="Edit Certification Page"><div className="py-8 text-center text-gray-400">Loading...</div></PrepAdminLayout>;

  return (
    <PrepAdminLayout title="Edit Certification Prep Page">
      <div className="max-w-xl space-y-6">
        <Card className="border-2">
          <CardHeader><CardTitle>Hero Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Page Headline</Label>
              <Input value={content.hero_headline || ''} onChange={e => set('hero_headline', e.target.value)} className="mt-1" />
            </div>
            <div>
              <Label>Page Description</Label>
              <Textarea rows={3} value={content.hero_description || ''} onChange={e => set('hero_description', e.target.value)} className="mt-1" />
            </div>
          </CardContent>
        </Card>
        <p className="text-sm text-gray-500 bg-blue-50 border border-blue-200 rounded p-3">
          The individual program cards (titles, prices, features) are managed in the <strong>Programs</strong> section of this admin panel.
        </p>
        <Button onClick={save} disabled={saving} className="bg-blue-600 hover:bg-blue-700 text-white w-full">
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </PrepAdminLayout>
  );
};
